<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="760px"
    custom-class="lease-ylw-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="110px"
      size="small"
      class="property-form"
    >
      <div class="lease-form-row">
        <div class="lease-form-col">
          <el-form-item label="关联基地" prop="fishBaseId">
            <el-select
              v-model="form.fishBaseId"
              filterable
              clearable
              placeholder="请选择基地"
              :disabled="readonly"
              @change="onBaseChange"
            >
              <el-option
                v-for="item in baseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="关联塘口" prop="fishPondId">
            <el-select
              v-model="form.fishPondId"
              filterable
              clearable
              placeholder="请选择塘口"
              :disabled="readonly"
              @change="onPondChange"
            >
              <el-option
                v-for="item in pondList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="标的物编号" prop="propertyCode">
            <el-input
              v-model="form.propertyCode"
              maxlength="50"
              clearable
              placeholder="请输入标的物编号"
              :disabled="readonly"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="类型" prop="type">
            <el-select
              v-model="form.type"
              placeholder="请选择类型"
              :disabled="readonly"
              @change="onTypeChange"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </div>
        <div v-if="isFishPond" class="lease-form-col">
          <el-form-item label="子类型" prop="subType">
            <el-select
              v-model="form.subType"
              placeholder="请选择子类型"
              clearable
              :disabled="readonly"
            >
              <el-option
                v-for="item in subTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="面积(亩)" prop="area">
            <el-input
              v-model="form.area"
              clearable
              placeholder="请输入面积"
              :disabled="readonly"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col">
          <el-form-item label="年租金(元)" prop="propertyRent">
            <el-input
              v-model="form.propertyRent"
              clearable
              placeholder="请输入年租金"
              :disabled="readonly"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col-full">
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="form.address"
              maxlength="200"
              clearable
              placeholder="请输入地址"
              :disabled="readonly"
            />
          </el-form-item>
        </div>
        <div
          v-for="(attr, index) in form.attrs"
          :key="attr.code || index"
          class="lease-form-col"
        >
          <el-form-item
            :label="attr.name || '属性'"
            :prop="'attrs.' + index + '.val'"
            :rules="attrRules(attr)"
          >
            <el-date-picker
              v-if="Number(attr.widgetType) === widgetType.Date"
              v-model="attr.val"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
              :disabled="readonly"
            />
            <el-input
              v-else
              v-model="attr.val"
              :maxlength="Number(attr.widgetType) === widgetType.Number ? 50 : 200"
              clearable
              placeholder="请输入"
              :disabled="readonly"
            >
              <template v-if="attr.valUnitTxt" slot="append">{{ attr.valUnitTxt }}</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="lease-form-col-full">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="请输入备注"
              :disabled="readonly"
            />
          </el-form-item>
        </div>
        <div class="lease-form-col-full">
          <el-form-item label="图片" prop="photoUrl">
            <lease-image-upload
              v-model="form.photoUrl"
              :limit="3"
              :disabled="readonly"
            />
          </el-form-item>
        </div>
      </div>
    </el-form>

    <span v-if="!readonly" slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
    </span>
    <span v-else slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import LeaseImageUpload from "@/components/fishPondLease/common/LeaseImageUpload.vue";
import {
  addProperty,
  editProperty,
  getProperty,
  listPropertyAttrDef,
  listLeaseFishBaseOptions,
  listLeaseFishPondOptions,
  getFishBaseDetail,
  getFishPondDetail,
  leaseRequestError
} from "@/service/fishPondLease.js";
import {
  PropertyType,
  PropertySubType,
  PropertyTypeOptions,
  PropertySubTypeOptions,
  WidgetType
} from "@/service/fishPondLeaseEnums.js";

function createEmptyForm() {
  return {
    id: "",
    propertyCode: "",
    type: PropertyType.FishPond,
    subType: PropertySubType.FreshWater,
    area: "",
    address: "",
    fishBaseId: "",
    fishPondId: "",
    propertyRent: "",
    remark: "",
    photoUrl: "",
    attrs: []
  };
}

function toIdStr(val) {
  if (val == null || val === "") return "";
  return String(val);
}

function formatArea(val) {
  if (val == null || val === "") return "";
  var n = Number(val);
  if (isNaN(n)) return String(val);
  return String(n);
}

export default {
  name: "PropertyFormDialog",
  components: {
    LeaseImageUpload: LeaseImageUpload
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      visible: false,
      saving: false,
      isEdit: false,
      typeOptions: PropertyTypeOptions,
      subTypeOptions: PropertySubTypeOptions,
      widgetType: WidgetType,
      baseList: [],
      allPondList: [],
      pondList: [],
      optionEnterpriseId: "",
      form: createEmptyForm(),
      rules: {
        propertyCode: [
          { required: true, message: "请输入标的物编号", trigger: "blur" }
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        area: [
          { required: true, message: "请输入面积", trigger: "blur" },
          {
            pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
            message: "面积须为数字，最多两位小数",
            trigger: "blur"
          }
        ],
        propertyRent: [
          { required: true, message: "请输入年租金", trigger: "blur" },
          {
            pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
            message: "年租金须为数字，最多两位小数",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    dialogTitle: function() {
      if (this.readonly) return "标的物详情";
      return this.isEdit ? "编辑标的物" : "新增标的物";
    },
    isFishPond: function() {
      return Number(this.form.type) === PropertyType.FishPond;
    }
  },
  methods: {
    attrRules: function(attr) {
      if (!attr || !attr.isMandatory) return [];
      return [
        {
          required: true,
          message: "请填写" + (attr.name || "属性"),
          trigger: "blur"
        }
      ];
    },
    openAdd: function() {
      var self = this;
      this.isEdit = false;
      this.optionEnterpriseId = "";
      this.form = createEmptyForm();
      this.visible = true;
      this.loadCompanyOptions()
        .then(function() {
          return self.loadAttrDefs(self.form.type);
        })
        .then(function() {
          self.$nextTick(function() {
            if (self.$refs.form) self.$refs.form.clearValidate();
          });
        });
    },
    openEdit: function(row) {
      var self = this;
      if (!row || !row.id) {
        this.$message.warning("缺少标的物信息");
        return;
      }
      this.isEdit = true;
      this.visible = true;
      this.form = createEmptyForm();
      getProperty(row.id)
        .then(function(res) {
          var data = (res && res.data) || {};
          self.applyDetail(data);
          return self.loadCompanyOptions(data.enterpriseId).then(function() {
            return self.loadAttrDefs(self.form.type, data.attrs || []);
          });
        })
        .then(function() {
          self.$nextTick(function() {
            if (self.$refs.form) self.$refs.form.clearValidate();
          });
        })
        .catch(function(e) {
          self.$message.error(leaseRequestError(e));
          self.visible = false;
        });
    },
    applyDetail: function(data) {
      this.form = {
        id: data.id,
        propertyCode: data.propertyCode || "",
        type: data.type != null ? data.type : PropertyType.FishPond,
        subType: data.subType != null ? data.subType : "",
        area: data.area != null && data.area !== "" ? String(data.area) : "",
        address: data.address || "",
        fishBaseId: toIdStr(data.fishBaseId),
        fishPondId: toIdStr(data.fishPondId),
        propertyRent:
          data.propertyRent != null && data.propertyRent !== ""
            ? String(data.propertyRent)
            : "",
        remark: data.remark || "",
        photoUrl: data.photoUrl || "",
        attrs: []
      };
      this.refreshPondList(this.form.fishBaseId);
    },
    handleClose: function() {
      this.saving = false;
      if (this.$refs.form) this.$refs.form.clearValidate();
    },
    loadCompanyOptions: function(enterpriseId) {
      var self = this;
      this.optionEnterpriseId = toIdStr(enterpriseId);
      this.baseList = [];
      this.allPondList = [];
      this.pondList = [];
      return listLeaseFishBaseOptions(this.optionEnterpriseId)
        .then(function(res) {
          var list = (res && res.data) || [];
          self.baseList = (Array.isArray(list) ? list : []).map(function(item) {
            return {
              id: toIdStr(item.id),
              name: item.name || "",
              address: item.address || ""
            };
          });
          return listLeaseFishPondOptions(self.optionEnterpriseId);
        })
        .then(function(res) {
          var list = (res && res.data) || [];
          self.allPondList = (Array.isArray(list) ? list : []).map(function(item) {
            return {
              id: toIdStr(item.id),
              name: item.name || "",
              fishBaseId: toIdStr(item.fishBaseId),
              area: item.area != null ? item.area : ""
            };
          });
          self.refreshPondList(self.form.fishBaseId);
        })
        .catch(function(e) {
          self.$message.error(leaseRequestError(e));
        });
    },
    findBase: function(baseId) {
      var id = toIdStr(baseId);
      if (!id) return null;
      for (var i = 0; i < this.baseList.length; i++) {
        if (this.baseList[i].id === id) return this.baseList[i];
      }
      return null;
    },
    findPond: function(pondId) {
      var id = toIdStr(pondId);
      if (!id) return null;
      var lists = [this.pondList, this.allPondList];
      for (var li = 0; li < lists.length; li++) {
        var list = lists[li] || [];
        for (var i = 0; i < list.length; i++) {
          if (list[i].id === id) return list[i];
        }
      }
      return null;
    },
    fillAddressFromBase: function(baseId) {
      var self = this;
      var id = toIdStr(baseId);
      if (!id) return Promise.resolve();
      var base = this.findBase(id);
      if (base && base.address) {
        this.form.address = base.address;
        return Promise.resolve();
      }
      return getFishBaseDetail(id)
        .then(function(res) {
          var data = (res && res.data) || {};
          var address = data.address || "";
          if (base) base.address = address;
          if (address) self.form.address = address;
        })
        .catch(function() {});
    },
    onTypeChange: function(type) {
      if (Number(type) !== PropertyType.FishPond) {
        this.form.subType = "";
      } else {
        this.form.subType = PropertySubType.FreshWater;
      }
      this.loadAttrDefs(type);
    },
    onBaseChange: function(baseId) {
      this.form.fishPondId = "";
      this.refreshPondList(baseId);
      if (baseId) {
        this.fillAddressFromBase(baseId);
      }
    },
    onPondChange: function(pondId) {
      var self = this;
      if (this.readonly) return;
      var id = toIdStr(pondId);
      if (!id) return;

      var local = this.findPond(id);
      if (local && local.name) {
        this.form.propertyCode = local.name;
      }
      if (local && local.area !== "" && local.area != null) {
        this.form.area = formatArea(local.area);
      }

      getFishPondDetail(id)
        .then(function(res) {
          var data = (res && res.data) || {};
          var pondName =
            data.pondNumber || data.fishPondNo || data.no || (local && local.name) || "";
          var pondArea =
            data.pondArea != null
              ? data.pondArea
              : data.area != null
                ? data.area
                : local && local.area;
          var baseId = toIdStr(
            data.fishBaseId || (local && local.fishBaseId) || self.form.fishBaseId
          );

          if (pondName) self.form.propertyCode = pondName;
          if (pondArea != null && pondArea !== "") {
            self.form.area = formatArea(pondArea);
          }
          if (baseId && baseId !== self.form.fishBaseId) {
            self.form.fishBaseId = baseId;
            self.refreshPondList(baseId);
          }
          if (baseId) {
            return self.fillAddressFromBase(baseId);
          }
        })
        .catch(function() {
          if (local && local.fishBaseId) {
            self.fillAddressFromBase(local.fishBaseId);
          } else if (self.form.fishBaseId) {
            self.fillAddressFromBase(self.form.fishBaseId);
          }
        });
    },
    refreshPondList: function(baseId) {
      var id = toIdStr(baseId);
      if (!id) {
        this.pondList = this.allPondList.slice();
        return;
      }
      this.pondList = this.allPondList.filter(function(p) {
        return p.fishBaseId === id;
      });
    },
    loadAttrDefs: function(type, existingAttrs) {
      var self = this;
      var t = type != null ? type : this.form.type;
      if (t == null || t === "") {
        this.form.attrs = [];
        return Promise.resolve();
      }
      return listPropertyAttrDef(t)
        .then(function(res) {
          var defs = (res && res.data) || [];
          var existMap = {};
          (existingAttrs || []).forEach(function(a) {
            var key = a.code || a.name;
            if (key) existMap[key] = a;
          });
          self.form.attrs = (Array.isArray(defs) ? defs : []).map(function(def) {
            var key = def.code || def.name;
            var old = existMap[key] || {};
            var val =
              old.val != null && old.val !== ""
                ? old.val
                : def.defaultValue || "";
            return {
              name: def.name || "",
              code: def.code || "",
              val: val,
              valCode: old.valCode || "",
              widgetType: def.widgetType,
              type: def.type != null ? def.type : t,
              valUnit: def.valUnit || "",
              valUnitTxt: def.valUnitTxt || "",
              valUnitType: def.valUnitType || "",
              sort: def.sort != null ? def.sort : 0,
              isMandatory: !!def.isMandatory
            };
          });
          if (!self.form.attrs.length && existingAttrs && existingAttrs.length) {
            self.form.attrs = existingAttrs.map(function(a, idx) {
              return {
                name: a.name || "",
                code: a.code || "",
                val: a.val,
                valCode: a.valCode || "",
                widgetType: a.widgetType,
                type: a.type != null ? a.type : t,
                valUnit: a.valUnit || "",
                valUnitTxt: a.valUnitTxt || "",
                valUnitType: a.valUnitType || "",
                sort: a.sort != null ? a.sort : idx,
                isMandatory: false
              };
            });
          }
        })
        .catch(function(e) {
          self.$message.error(leaseRequestError(e));
          self.form.attrs = [];
        });
    },
    buildPayload: function() {
      var payload = {
        propertyCode: (this.form.propertyCode || "").trim(),
        type: this.form.type,
        area: Number(this.form.area),
        address: this.form.address || "",
        propertyRent: Number(this.form.propertyRent),
        remark: this.form.remark || "",
        photoUrl: this.form.photoUrl || "",
        fishBaseId: this.form.fishBaseId || null,
        fishPondId: this.form.fishPondId || null,
        attrs: (this.form.attrs || []).map(function(a) {
          return {
            name: a.name,
            code: a.code,
            val: a.val != null && a.val !== undefined ? String(a.val) : "",
            valCode: a.valCode || "",
            widgetType: a.widgetType,
            type: a.type,
            valUnit: a.valUnit || "",
            valUnitTxt: a.valUnitTxt || "",
            valUnitType: a.valUnitType || "",
            sort: a.sort || 0
          };
        })
      };
      if (Number(this.form.type) === PropertyType.FishPond) {
        payload.subType = this.form.subType !== "" ? this.form.subType : null;
      } else {
        payload.subType = null;
      }
      if (this.isEdit) {
        payload.id = this.form.id;
      }
      return payload;
    },
    submit: function() {
      var self = this;
      if (this.readonly) return;
      this.$refs.form.validate(function(valid) {
        if (!valid) return;
        if (
          self.isFishPond &&
          (self.form.subType === "" || self.form.subType == null)
        ) {
          self.$message.warning("请选择子类型");
          return;
        }
        var payload = self.buildPayload();
        self.saving = true;
        var req = self.isEdit ? editProperty(payload) : addProperty(payload);
        req
          .then(function() {
            self.$message.success(self.isEdit ? "保存成功" : "新增成功");
            self.visible = false;
            self.$emit("success");
          })
          .catch(function(e) {
            self.$message.error(leaseRequestError(e));
          })
          .then(function() {
            self.saving = false;
          });
      });
    }
  }
};
</script>
